import { Accordion, AccordionDetails, AccordionSummary, Box, Dialog, DialogContent, DialogTitle, Grid, MenuItem, Typography, useMediaQuery, useTheme } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ClearIcon from '@mui/icons-material/Clear';
import { TitleText } from '../../../component/layout/layoutMainStyle'
import FilterSelect from '../../../component/select/filterSelect';
import InputCheckbox from '../../../component/input/inputCheckbox';
import { icons } from '../../../constants/images';
import InputTextField from '../../../component/input/inputTextField';
import ButtonCustom from '../../../component/button/buttonCustom';
import { useDropzone } from 'react-dropzone';
import { useEffect, useState } from 'react';
import BoxDoc from '../../../component/boxDoc/boxDoc';
import PDFViewer from '../../../component/viewer/pdfViewer';
import FolderApi from '../../../api/folder/folder.api';
import { swalError, swalSuccess } from '../../../component/notification/swal';
import FileApi from '../../../api/file/file.api';
import UploadIcon from '@mui/icons-material/Upload';
const initStateErrorMessage = {
    formDocument_0_Name: "",
    formDocument_1_Name: "",
    formDocument_2_Name: "",
    formDocument_3_Name: "",
    formDocument_4_Name: "",
    formDocument_5_Name: "",
    formDocument_6_Name: "",
    formDocument_7_Name: "",
    formDocument_8_Name: "",
    formDocument_9_Name: "",
    idDocumentSize: "",
    idDocumentType: ""
};

type PropsDialogUpload = {
    openUploadFile: boolean
    setOpenUploadFile: any
    file: any
    setFile: any
    loading: boolean
    submit: any
    idFolder: number
    type?: string
}
export default function DialogUpload(props: PropsDialogUpload) {
    const theme = useTheme();

    const fullScreen = useMediaQuery(theme.breakpoints.down("lg"));
    const [errorMessage, setErrorMessage] = useState<any>(initStateErrorMessage);
    const clearErrorMessage = () => setErrorMessage(initStateErrorMessage);
    const { openUploadFile, setOpenUploadFile, file, setFile, loading, submit, idFolder, type } = props
    const [settingUpload, setSettingUpload] = useState(false);
    const [copyIndex, setCopyIndex] = useState(false);
    const [listFiles, setListFiles] = useState<any>([]);
    const [viewType, setViewType] = useState<string>('column')
    const [openFile, setOpenFile] = useState<boolean>(false);
    const [fileIndex, setFileIndex] = useState<number>(0);
    const [idDocumentSize, setIdDocumentSize] = useState<number>();
    const [idDocumentType, setIdDocumentType] = useState<number>();
    const [index, setIndex] = useState<any>({
        size: null,
        Type: null
    })
    const [documentSize, setDocumentSize] = useState<any>([])
    const [documentType, setDocumentType] = useState<any>([])
    const [permission, setPermission] = useState<any>([
        {
            name: "ปีงบประมาณ",
            status: true
        }
    ])


    const { getRootProps, getInputProps, open, acceptedFiles, fileRejections } = useDropzone({
        noClick: true,
        noKeyboard: true,
        maxSize: index?.size && +index?.size?.documentSizeValue || 10000000,
        accept: index?.type && JSON.parse(index?.type?.mimeType) || {
            'image/png': ['.png'],
            'image/jpeg': ['.jpeg'],
            "application/pdf": [".pdf"],
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                [".docx"],
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
            "application/msword": [".doc"],
            "application/vnd.sketchup.skp": [".skp"],
            "application/acad": [".dwg"],
            "application/x-acad": [".dwg"],
            "application/autocad_dwg": [".dwg"],
            "image/vnd.dwg": [".dwg"],
            "application/dxf": [".dxf"],
            "image/vnd.dxf": [".dxf"],
            "application/x-dxf": [".dxf"],
            "model/vnd.dwf": [".dwf"],
            "application/x-dwf": [".dwf"]
        },
        onDropRejected: (fileRejections) => {
            swalError(fileRejections[0].errors.map((x) => x.code === 'file-invalid-type' ? 'ไม่สามารถเพิ่มไฟล์ประเภทนี้ได้' : x.code === 'file-too-large' ? 'ไฟล์มีขนาดใหญ่เกินไป' : 'ไม่สามารถเพิ่มไฟล์นี้ได้').join('/'))
        },
    });

    const getFormDocument = async () => {
        const res = await FolderApi.getFormDocument(idFolder)
        const data = res.data
        if (data?.success) {
            setIdDocumentSize(data.result.idDocumentSize)
            setIdDocumentType(data.result.idDocumentType)
            setIndex({
                size: documentSize.length > 0 ? documentSize.find((x: any) => x.idDocumentSize === data.result.idDocumentSize) : null,
                type: documentType.length > 0 ? documentType.find((x: any) => x.idDocumentType === data.result.idDocumentType) : null
            })
            data.result.detailFormDocument.length === 0 ? setPermission(permission) : setPermission(data.result.detailFormDocument)
        }
    }
    const getDocumentSize = async () => {
        const res = await FolderApi.getDocumentSize()
        const data = res.data
        if (data?.success) {
            setDocumentSize(data.result)
        }
    }
    const getDocumentType = async () => {
        const res = await FolderApi.getDocumentType()
        const data = res.data
        if (data?.success) {
            setDocumentType(data.result)
        }
    }

    useEffect(() => {
        if (acceptedFiles.length > 0) {
            if (type === 'My') {
                const loadDataLevel = async () => {
                    const res = await FolderApi.getMyFolder(idFolder)
                    const data = await res.data;
                    if (data?.success) {
                        setFile([...file, ...acceptedFiles.map((x) => {
                            return {
                                ...data.result.formDocument,
                                fileName: x.name,
                                fileLocation: "",
                                formDocument_0_Name: data.result.formDocument?.formDocument_0,
                                formDocument_0_Value: null,
                                formDocument_1_Name: data.result.formDocument?.formDocument_1,
                                formDocument_1_Value: null,
                                formDocument_2_Name: data.result.formDocument?.formDocument_2,
                                formDocument_2_Value: null,
                                formDocument_3_Name: data.result.formDocument?.formDocument_3,
                                formDocument_3_Value: null,
                                formDocument_4_Name: data.result.formDocument?.formDocument_4,
                                formDocument_4_Value: null,
                                formDocument_5_Name: data.result.formDocument?.formDocument_5,
                                formDocument_5_Value: null,
                                formDocument_6_Name: data.result.formDocument?.formDocument_6,
                                formDocument_6_Value: null,
                                formDocument_7_Name: data.result.formDocument?.formDocument_7,
                                formDocument_7_Value: null,
                                formDocument_8_Name: data.result.formDocument?.formDocument_8,
                                formDocument_8_Value: null,
                                formDocument_9_Name: data.result.formDocument?.formDocument_9,
                                formDocument_9_Value: null,
                                file: x
                            }
                        })]
                        );
                        setListFiles(data.result.detailFiles)
                    }
                }
                loadDataLevel()
            } else {
                const loadDataLevel = async () => {
                    const res = await FolderApi.getSharedFolder(idFolder)
                    const data = await res.data;
                    if (data?.success) {
                        setFile([...file, ...acceptedFiles.map((x) => {
                            return {
                                ...data.result.formDocument,
                                fileName: x.name,
                                fileLocation: "",
                                formDocument_0_Name: data.result.formDocument?.formDocument_0,
                                formDocument_0_Value: null,
                                formDocument_1_Name: data.result.formDocument?.formDocument_1,
                                formDocument_1_Value: null,
                                formDocument_2_Name: data.result.formDocument?.formDocument_2,
                                formDocument_2_Value: null,
                                formDocument_3_Name: data.result.formDocument?.formDocument_3,
                                formDocument_3_Value: null,
                                formDocument_4_Name: data.result.formDocument?.formDocument_4,
                                formDocument_4_Value: null,
                                formDocument_5_Name: data.result.formDocument?.formDocument_5,
                                formDocument_5_Value: null,
                                formDocument_6_Name: data.result.formDocument?.formDocument_6,
                                formDocument_6_Value: null,
                                formDocument_7_Name: data.result.formDocument?.formDocument_7,
                                formDocument_7_Value: null,
                                formDocument_8_Name: data.result.formDocument?.formDocument_8,
                                formDocument_8_Value: null,
                                formDocument_9_Name: data.result.formDocument?.formDocument_9,
                                formDocument_9_Value: null,
                                file: x
                            }
                        })]);

                    }
                    setListFiles(data.result.detailFiles)

                }
                loadDataLevel()
            }


        }


    }, [acceptedFiles])


    useEffect(() => {
        if (openUploadFile) {
            setFile([])
            setFileIndex(0)
            setSettingUpload(false)
            setCopyIndex(false)
            clearErrorMessage()
            getDocumentType()
            getDocumentSize()
            getFormDocument()
        }
    }, [openUploadFile])


    const patchPermissionFolder = async () => {
        if (!idDocumentSize)
            return setErrorMessage({
                ...errorMessage,
                ...{ idDocumentSize: 'กรุณาเพิ่มข้อมูล' },
            })
        if (!idDocumentType)
            return setErrorMessage({
                ...errorMessage,
                ...{ idDocumentType: 'กรุณาเพิ่มข้อมูล' },
            })
        const body = {
            idDocumentSize: idDocumentSize,
            idDocumentType: idDocumentType,
            detailFormDocument: permission
        }
        await FolderApi.patchFormDocument(idFolder, body).then(async (res) => {
            if (res?.data?.success) {
                swalSuccess("อัพเดทสิทธิ์สำเร็จ")
                getFormDocument()
            } else {
                swalError(res.data.description || res.data.message);
            }

        }).catch((error: any) => {
            swalError(error.response.data.description || error.response.data.message);
        })
    }
    const handleSubmit = async () => {
        if (file[0]?.formDocument_0_Status && !file[0]?.formDocument_0_Value)
            return setErrorMessage({
                ...errorMessage,
                ...{ formDocument_0_Name: 'กรุณาเพิ่มข้อมูล' },
            })
        if (file[0]?.formDocument_1_Status && !file[0]?.formDocument_1_Value)
            return setErrorMessage({
                ...errorMessage,
                ...{ formDocument_1_Name: 'กรุณาเพิ่มข้อมูล' },
            });
        if (file[0]?.formDocument_2_Status && !file[0]?.formDocument_2_Value)
            return setErrorMessage({
                ...errorMessage,
                ...{ formDocument_2_Name: 'กรุณาเพิ่มข้อมูล' },
            });
        if (file[0]?.formDocument_3_Status && !file[0]?.formDocument_3_Value)
            return setErrorMessage({
                ...errorMessage,
                ...{ formDocument_3_Name: 'กรุณาเพิ่มข้อมูล' },
            });
        if (file[0]?.formDocument_4_Status && !file[0]?.formDocument_4_Value)
            return setErrorMessage({
                ...errorMessage,
                ...{ formDocument_4_Name: 'กรุณาเพิ่มข้อมูล' },
            });
        if (file[0]?.formDocument_5_Status && !file[0]?.formDocument_5_Value)
            return setErrorMessage({
                ...errorMessage,
                ...{ formDocument_5_Name: 'กรุณาเพิ่มข้อมูล' },
            });
        if (file[0]?.formDocument_6_Status && !file[0]?.formDocument_6_Value)
            return setErrorMessage({
                ...errorMessage,
                ...{ formDocument_6_Name: 'กรุณาเพิ่มข้อมูล' },
            });
        if (file[0]?.formDocument_7_Status && !file[0]?.formDocument_7_Value)
            return setErrorMessage({
                ...errorMessage,
                ...{ formDocument_7_Name: 'กรุณาเพิ่มข้อมูล' },
            });
        if (file[0]?.formDocument_8_Status && !file[0]?.formDocument_8_Value)
            return setErrorMessage({
                ...errorMessage,
                ...{ formDocument_8_Name: 'กรุณาเพิ่มข้อมูล' },
            });
        if (file[0]?.formDocument_9_Status && !file[0]?.formDocument_9_Value)
            return setErrorMessage({
                ...errorMessage,
                ...{ formDocument_9_Name: 'กรุณาเพิ่มข้อมูล' },
            });

        submit()
        clearErrorMessage()

    }
    const handleClose = () => {
        setOpenUploadFile(false)
        setCopyIndex(false)
        setFileIndex(0)
        setFile([])
        clearErrorMessage()
    }
    const getFileDetail = async (idFile: number) => {
        const res = await FileApi.getFile(idFile)
        const data = res.data
        if (data?.success) {
            setFile(acceptedFiles.map((x) => {
                return {
                    ...data.result.fileFormDocument,
                    fileName: x.name,
                    fileLocation: "",
                    // formDocument_0_Value: null,
                    // formDocument_1_Value: null,
                    // formDocument_2_Value: null,
                    // formDocument_3_Value: null,
                    // formDocument_4_Value: null,
                    // formDocument_5_Value: null,
                    // formDocument_6_Value: null,
                    // formDocument_7_Value: null,
                    // formDocument_8_Value: null,
                    // formDocument_9_Value: null,
                    file: x
                }
            }));
            setCopyIndex(false)
        }
    }
    const getFileIndex = (file:any) => {
        setFile(acceptedFiles.map((x) => {
            return {
                ...file.fileFormDocument,
                fileName: x.name,
                fileLocation: "",
                // formDocument_0_Value: null,
                // formDocument_1_Value: null,
                // formDocument_2_Value: null,
                // formDocument_3_Value: null,
                // formDocument_4_Value: null,
                // formDocument_5_Value: null,
                // formDocument_6_Value: null,
                // formDocument_7_Value: null,
                // formDocument_8_Value: null,
                // formDocument_9_Value: null,
                file: x
            }
        }));
        setCopyIndex(false)
    }
    return (
        <Dialog
            fullWidth={!fullScreen}
            fullScreen={fullScreen}
            maxWidth={false}
            sx={{ maxWidth: settingUpload ? '504px' : copyIndex ? '1329px' : '1329px', margin: 'auto', }}
            open={openUploadFile}
            onClose={() => {
                handleClose()
            }}>

            {settingUpload ?
                <DialogContent sx={{ padding: '40px 32px', position: 'relative' }}>
                    <TitleText sx={{ textAlign: "center" }}>ตั้งค่าอัปโหลดเอกสาร</TitleText>
                    <div style={{ overflowY: 'auto', marginBottom: '20px', }}>
                        <Accordion defaultExpanded sx={{
                            padding: '0px',
                            boxShadow: 'none', ':before': {
                                content: '""',
                                height: "0px"
                            }
                        }}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                                style={{ padding: '0px' }}
                            >
                                <Typography sx={{ fontWeight: '500' }}>ขนาดไฟล์</Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ display: 'flex', flexDirection: 'column', gap: '20px', padding: '0px' }}>
                                <div>
                                    <FilterSelect heading='ขนาดไฟล์สูงสุด' labelId='' selectId='' options={documentSize.map((x: any, i: number) => {
                                        return (
                                            <MenuItem key={i}
                                                value={x.idDocumentSize}
                                            >
                                                {x.documentSizeName}
                                            </MenuItem>
                                        )
                                    })} value={idDocumentSize} style={{ width: '140px' }} onchange={(e: any) => {
                                        setIdDocumentSize(e.target.value)
                                        clearErrorMessage()
                                    }}
                                        helperText={
                                            errorMessage.idDocumentSize || ''
                                        } />
                                </div>
                                <div>
                                    <FilterSelect heading='ประเภทไฟล์' labelId='' selectId='' options={documentType.map((x: any, i: number) => {
                                        return (
                                            <MenuItem key={i}
                                                value={x.idDocumentType}
                                            >
                                                {x.documentType}
                                            </MenuItem>
                                        )
                                    })} value={idDocumentType} style={{ width: '140px' }} onchange={(e: any) => {
                                        setIdDocumentType(e.target.value)
                                        clearErrorMessage()
                                    }}
                                        helperText={
                                            errorMessage.idDocumentType || ''
                                        } />
                                </div>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion defaultExpanded sx={{
                            boxShadow: 'none', ':before': {
                                content: '""',
                                height: "0px"
                            }
                        }}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                                style={{ padding: '0px' }}

                            >
                                <Typography sx={{ fontWeight: '500' }}>ดัชนีข้อมูลเอกสาร</Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ display: 'flex', flexDirection: 'column', gap: '20px', padding: '0px' }}>
                                {permission?.map((item: any, i: number) => {
                                    return (
                                        <div key={i}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <InputCheckbox label='บังคับ' checked={item?.status} onChange={(e) => {
                                                        setPermission((prevData: any) => {
                                                            const newData = [...prevData];
                                                            newData[i] = { ...newData[i], status: e.target.checked };
                                                            return newData;
                                                        });
                                                    }} />
                                                    <InputCheckbox label='ไม่บังคับ' checked={!item?.status} onChange={(e) => {
                                                        setPermission((prevData: any) => {
                                                            const newData = [...prevData];
                                                            newData[i] = { ...newData[i], status: !e.target.checked };
                                                            return newData;
                                                        });
                                                    }} />
                                                </div>
                                                {item?.name === 'ปีงบประมาณ' ? <></> : <icons.sup_trash style={{ cursor: "pointer" }} onClick={() => {
                                                    setPermission(permission.filter((x: any, index: number) => i !== index))
                                                }} />}
                                            </div>

                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Typography sx={{ whiteSpace: 'nowrap', marginRight: '8px' }}>ชื่อดัชนี</Typography>
                                                <InputTextField heading='' value={item?.name} onchange={(e) => {
                                                    setPermission((prevData: any) => {
                                                        const newData = [...prevData];
                                                        newData[i] = { ...newData[i], name: e.target.value };
                                                        return newData;
                                                    });
                                                }} />
                                            </div>
                                        </div>
                                    )

                                })}

                                <div style={{ display: 'flex', justifyContent: "flex-end" }}>
                                    <ButtonCustom disabled={permission?.length > 9} variant={'outlined'}
                                        startIcon={<icons.circleButton />}
                                        textButton={'เพิ่ม'}
                                        onClick={() => {
                                            setPermission([...permission, {
                                                name: "",
                                                status: true
                                            }])
                                        }} />
                                </div>
                            </AccordionDetails>
                        </Accordion>



                    </div>
                    <div style={{ display: "flex", justifyContent: 'flex-end' }}>
                        <ButtonCustom variant={'outlined'}
                            // startIcon={<icons.iconUpload />}
                            textButton={'ย้อนกลับ'}
                            onClick={() => {
                                {
                                    setSettingUpload(false)
                                    if (type === 'My') {
                                        const loadDataLevel = async () => {
                                            const res = await FolderApi.getMyFolder(idFolder)
                                            const data = await res.data;
                                            if (data?.success) {
                                                setFile(acceptedFiles.map((x) => {
                                                    return {
                                                        ...data.result.formDocument,
                                                        fileName: x.name,
                                                        fileLocation: "",
                                                        formDocument_0_Name: data.result.formDocument?.formDocument_0,
                                                        formDocument_0_Value: null,
                                                        formDocument_1_Name: data.result.formDocument?.formDocument_1,
                                                        formDocument_1_Value: null,
                                                        formDocument_2_Name: data.result.formDocument?.formDocument_2,
                                                        formDocument_2_Value: null,
                                                        formDocument_3_Name: data.result.formDocument?.formDocument_3,
                                                        formDocument_3_Value: null,
                                                        formDocument_4_Name: data.result.formDocument?.formDocument_4,
                                                        formDocument_4_Value: null,
                                                        formDocument_5_Name: data.result.formDocument?.formDocument_5,
                                                        formDocument_5_Value: null,
                                                        formDocument_6_Name: data.result.formDocument?.formDocument_6,
                                                        formDocument_6_Value: null,
                                                        formDocument_7_Name: data.result.formDocument?.formDocument_7,
                                                        formDocument_7_Value: null,
                                                        formDocument_8_Name: data.result.formDocument?.formDocument_8,
                                                        formDocument_8_Value: null,
                                                        formDocument_9_Name: data.result.formDocument?.formDocument_9,
                                                        formDocument_9_Value: null,
                                                        file: x
                                                    }
                                                }));
                                            }
                                        }
                                        loadDataLevel()
                                    } else {
                                        const loadDataLevel = async () => {
                                            const res = await FolderApi.getSharedFolder(idFolder)
                                            const data = await res.data;
                                            if (data?.success) {
                                                setFile(acceptedFiles.map((x) => {
                                                    return {
                                                        ...data.result.formDocument,
                                                        fileName: x.name,
                                                        fileLocation: "",
                                                        formDocument_0_Name: data.result.formDocument?.formDocument_0,
                                                        formDocument_0_Value: null,
                                                        formDocument_1_Name: data.result.formDocument?.formDocument_1,
                                                        formDocument_1_Value: null,
                                                        formDocument_2_Name: data.result.formDocument?.formDocument_2,
                                                        formDocument_2_Value: null,
                                                        formDocument_3_Name: data.result.formDocument?.formDocument_3,
                                                        formDocument_3_Value: null,
                                                        formDocument_4_Name: data.result.formDocument?.formDocument_4,
                                                        formDocument_4_Value: null,
                                                        formDocument_5_Name: data.result.formDocument?.formDocument_5,
                                                        formDocument_5_Value: null,
                                                        formDocument_6_Name: data.result.formDocument?.formDocument_6,
                                                        formDocument_6_Value: null,
                                                        formDocument_7_Name: data.result.formDocument?.formDocument_7,
                                                        formDocument_7_Value: null,
                                                        formDocument_8_Name: data.result.formDocument?.formDocument_8,
                                                        formDocument_8_Value: null,
                                                        formDocument_9_Name: data.result.formDocument?.formDocument_9,
                                                        formDocument_9_Value: null,
                                                        file: x
                                                    }
                                                }));
                                            }
                                        }
                                        loadDataLevel()
                                    }
                                }
                            }}
                            style={{ marginRight: '4px' }}
                            btnStyle={{
                                '&.MuiButton-outlined': {
                                    color: `#EEA23E !important`,
                                    border: `2px solid #EEA23E !important`,
                                    borderRadius: "10px !important",
                                    '&:hover': {
                                        color: `#EEA23E  !important`,
                                        border: `2px solid #EEA23E !important`,
                                        backgroundColor: '#FFFAF2 !important'
                                    },
                                },
                            }} />
                        <ButtonCustom variant={'outlined'}
                            textButton={'คืนค่า'}
                            style={{ marginRight: '4px' }}
                            onClick={() => { getFormDocument() }} />
                        <ButtonCustom variant={'outlined'}
                            // endIcon={<icons.downloadButton />}
                            textButton={'บันทึก'}
                            onClick={() => { patchPermissionFolder() }}
                            btnStyle={{
                                '&.MuiButton-outlined': {
                                    color: `#fff !important`,
                                    border: `2px solid #026735 !important`,
                                    backgroundColor: '#026735 !important',
                                    borderRadius: "10px !important",
                                    '&:hover': {
                                        color: `#fff  !important`,
                                        border: `2px solid #026735 !important`,
                                        backgroundColor: '#026735 !important'
                                    },
                                },
                            }} />

                    </div>
                    <ClearIcon sx={{ cursor: 'pointer', fontSize: "20px", position: 'absolute', top: '20px', right: '16px' }} onClick={() => {
                        handleClose()
                        clearErrorMessage()
                    }} />

                </DialogContent>
                : copyIndex ?
                    <DialogContent sx={{ padding: '40px 32px', position: 'relative' }}>
                        <TitleText sx={{ textAlign: "center" }}>คัดลอกดัชนี</TitleText>
                        <div style={{ overflowY: 'auto', marginBottom: '20px', }}>

                            {listFiles?.length > 0 ? listFiles?.map((item: any, i: number) => {
                                return (
                                    <Box onClick={() => getFileIndex(item)} sx={{
                                        
                                        padding: "12px", cursor: "pointer", ':hover': {
                                            backgroundColor: '#e3e3e3 !important'
                                        }
                                    }}>
                                        <Box sx={{display: 'flex', alignItems: "center",}}>
                                        <icons.file style={{ marginRight: "10px" }} /> <Typography>{item?.fileName}</Typography>
                                        </Box>
                                        <Typography sx={{color:"#a9a9a9", fontSize:"14px", marginTop:'10px'}}>{item?.index}</Typography>

                                    </Box>
                                )
                            }) : <Typography>ไม่พบไฟล์</Typography>}
                        </div>
                        <div style={{ display: "flex", justifyContent: 'flex-end' }}>
                            <ButtonCustom variant={'outlined'}
                                // startIcon={<icons.iconUpload />}
                                textButton={'ย้อนกลับ'}
                                onClick={() => {
                                    {
                                        setCopyIndex(false)
                                        // if (type === 'My') {
                                        //     const loadDataLevel = async () => {
                                        //         const res = await FolderApi.getMyFolder(idFolder)
                                        //         const data = await res.data;
                                        //         if (data?.success) {
                                        //             setFile(acceptedFiles.map((x) => {
                                        //                 return {
                                        //                     ...data.result.formDocument,
                                        //                     fileName: x.name,
                                        //                     fileLocation: "",
                                        //                     formDocument_0_Name: data.result.formDocument?.formDocument_0,
                                        //                     formDocument_0_Value: null,
                                        //                     formDocument_1_Name: data.result.formDocument?.formDocument_1,
                                        //                     formDocument_1_Value: null,
                                        //                     formDocument_2_Name: data.result.formDocument?.formDocument_2,
                                        //                     formDocument_2_Value: null,
                                        //                     formDocument_3_Name: data.result.formDocument?.formDocument_3,
                                        //                     formDocument_3_Value: null,
                                        //                     formDocument_4_Name: data.result.formDocument?.formDocument_4,
                                        //                     formDocument_4_Value: null,
                                        //                     formDocument_5_Name: data.result.formDocument?.formDocument_5,
                                        //                     formDocument_5_Value: null,
                                        //                     formDocument_6_Name: data.result.formDocument?.formDocument_6,
                                        //                     formDocument_6_Value: null,
                                        //                     formDocument_7_Name: data.result.formDocument?.formDocument_7,
                                        //                     formDocument_7_Value: null,
                                        //                     formDocument_8_Name: data.result.formDocument?.formDocument_8,
                                        //                     formDocument_8_Value: null,
                                        //                     formDocument_9_Name: data.result.formDocument?.formDocument_9,
                                        //                     formDocument_9_Value: null,
                                        //                     file: x
                                        //                 }
                                        //             }));
                                        //         }
                                        //     }
                                        //     loadDataLevel()
                                        // } else {
                                        //     const loadDataLevel = async () => {
                                        //         const res = await FolderApi.getSharedFolder(idFolder)
                                        //         const data = await res.data;
                                        //         if (data?.success) {
                                        //             setFile(acceptedFiles.map((x) => {
                                        //                 return {
                                        //                     ...data.result.formDocument,
                                        //                     fileName: x.name,
                                        //                     fileLocation: "",
                                        //                     formDocument_0_Name: data.result.formDocument?.formDocument_0,
                                        //                     formDocument_0_Value: null,
                                        //                     formDocument_1_Name: data.result.formDocument?.formDocument_1,
                                        //                     formDocument_1_Value: null,
                                        //                     formDocument_2_Name: data.result.formDocument?.formDocument_2,
                                        //                     formDocument_2_Value: null,
                                        //                     formDocument_3_Name: data.result.formDocument?.formDocument_3,
                                        //                     formDocument_3_Value: null,
                                        //                     formDocument_4_Name: data.result.formDocument?.formDocument_4,
                                        //                     formDocument_4_Value: null,
                                        //                     formDocument_5_Name: data.result.formDocument?.formDocument_5,
                                        //                     formDocument_5_Value: null,
                                        //                     formDocument_6_Name: data.result.formDocument?.formDocument_6,
                                        //                     formDocument_6_Value: null,
                                        //                     formDocument_7_Name: data.result.formDocument?.formDocument_7,
                                        //                     formDocument_7_Value: null,
                                        //                     formDocument_8_Name: data.result.formDocument?.formDocument_8,
                                        //                     formDocument_8_Value: null,
                                        //                     formDocument_9_Name: data.result.formDocument?.formDocument_9,
                                        //                     formDocument_9_Value: null,
                                        //                     file: x
                                        //                 }
                                        //             }));
                                        //         }
                                        //     }
                                        //     loadDataLevel()
                                        // }
                                    }
                                }}
                                style={{ marginRight: '4px' }}
                                btnStyle={{
                                    '&.MuiButton-outlined': {
                                        color: `#EEA23E !important`,
                                        border: `2px solid #EEA23E !important`,
                                        borderRadius: "10px !important",
                                        '&:hover': {
                                            color: `#EEA23E  !important`,
                                            border: `2px solid #EEA23E !important`,
                                            backgroundColor: '#FFFAF2 !important'
                                        },
                                    },
                                }} />

                            {/* <ButtonCustom variant={'outlined'}
                                // endIcon={<icons.downloadButton />}
                                textButton={'บันทึก'}
                                onClick={() => { patchPermissionFolder() }}
                                btnStyle={{
                                    '&.MuiButton-outlined': {
                                        color: `#fff !important`,
                                        border: `2px solid #026735 !important`,
                                        backgroundColor: '#026735 !important',
                                        borderRadius: "10px !important",
                                        '&:hover': {
                                            color: `#fff  !important`,
                                            border: `2px solid #026735 !important`,
                                            backgroundColor: '#026735 !important'
                                        },
                                    },
                                }} /> */}

                        </div>
                        <ClearIcon sx={{ cursor: 'pointer', fontSize: "20px", position: 'absolute', top: '20px', right: '16px' }} onClick={() => {
                            handleClose()
                            clearErrorMessage()
                        }} />
                    </DialogContent> :
                    <DialogContent sx={{ padding: '0px', position: 'relative' }}>
                        {file?.length > 0 ? <Box sx={{ padding: '0px' }}>
                            <Box sx={{ display: { lg: 'flex', xs: 'block' } }}>
                                <Box sx={{ display: { lg: 'block', xs: 'none' }, width: { lg: '63%', xs: '100%' }, height: '800px', background: "#F8F9FB", padding: '40px 32px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", marginBottom: "20px" }}>
                                        {(file && !openFile) ? <>
                                            <Typography>
                                                เอกสารที่อัปโหลด
                                            </Typography>
                                            {/* <div style={{ display: "flex", alignItems: 'center', gap: '8px' }}>

                                                <FormatListBulletedIcon sx={{ cursor: "pointer", color: viewType !== 'column' ? '#858C95' : '#026735', fontSize: '18px' }} onClick={() => setViewType('column')} />
                                                <GridViewIcon sx={{ cursor: "pointer", color: viewType === 'column' ? '#858C95' : '#026735', fontSize: '18px' }} onClick={() => setViewType('box')} />
                                            </div> */}
                                        </>
                                            :
                                            <div style={{ display: 'flex' }}>
                                                <Typography onClick={() => { setOpenFile(false) }} sx={{ marginRight: '12px', cursor: 'pointer' }}>{' < '}</Typography>
                                                <Typography>
                                                    ชื่อไฟล์.Pdf
                                                </Typography>
                                            </div>
                                        }

                                    </div>
                                    {(file && !openFile) ?
                                        <Grid container columns={8} spacing={2} sx={{
                                        }}>
                                            {file.map((x: any, i: number) => {
                                                return (
                                                    <BoxDoc id={x.idFile} style={{ border: fileIndex === i ? '2px solid #026735' : 'none', borderRadius: '10px' }} icon={<icons.box5 />} title={x?.fileName} onClick={() => { setFileIndex(i) }} dropDown checkbox />
                                                )
                                            })}
                                            <Grid item lg={2} sx={{ cursor: 'pointer', position: 'relative', }}>
                                                <Box sx={{ padding: '10px' }} {...getRootProps({ className: 'dropzone' })}>
                                                    <input {...getInputProps()} />
                                                    <Box onClick={open} sx={{
                                                        position: 'relative',
                                                        display: 'flex',
                                                        width: '140px',
                                                        height: '140px',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        borderRadius: 'var(--main-system-4-px, 4px)',
                                                        border: '1px dashed #C1C3C7',
                                                    }}><UploadIcon sx={{ fontSize: '32px', color: "#C1C3C7" }} /></Box>
                                                </Box>
                                            </Grid>

                                        </Grid> :
                                        <PDFViewer file={file} style={{ width: '100%', height: '75vh' }} />}

                                </Box>
                                <Box sx={{ width: { lg: '37%', xs: '100%' }, height: '800px', background: "#fff", padding: '40px 32px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', position: 'relative' }}>
                                    <>
                                        <div style={{ overflowY: 'auto', marginBottom: '20px' }}>
                                            <Accordion defaultExpanded sx={{
                                                display: { lg: 'none', xs: 'block' },
                                                padding: '0px',
                                                boxShadow: 'none', ':before': {
                                                    content: '""',
                                                    height: "0px"
                                                }
                                            }}>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                    style={{ padding: '0px' }}
                                                >
                                                    <Typography sx={{ fontWeight: '500' }}>เอกสารที่อัปโหลด</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails sx={{ display: 'flex', flexDirection: 'column', gap: '20px', padding: '0px' }}>
                                                    {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", marginBottom: "20px" }}>
                                                        {(file && !openFile) ? <>
                                                            <Typography>

                                                            </Typography>
                                                            <div style={{ display: "flex", alignItems: 'center', gap: '8px' }}>

                                                                <FormatListBulletedIcon sx={{ cursor: "pointer", color: viewType !== 'column' ? '#858C95' : '#026735', fontSize: '18px' }} onClick={() => setViewType('column')} />
                                                                <GridViewIcon sx={{ cursor: "pointer", color: viewType === 'column' ? '#858C95' : '#026735', fontSize: '18px' }} onClick={() => setViewType('box')} />
                                                            </div>
                                                        </>
                                                            :
                                                            <div style={{ display: 'flex' }}>
                                                                <Typography onClick={() => { setOpenFile(false) }} sx={{ marginRight: '12px', cursor: 'pointer' }}>{' < '}</Typography>
                                                                <Typography>
                                                                    ชื่อไฟล์.Pdf
                                                                </Typography>
                                                            </div>
                                                        }

                                                    </div> */}
                                                    {(file && !openFile) ?
                                                        <Grid container columns={8} spacing={2} sx={{
                                                        }}>
                                                            {file.map((x: any, i: number) => {
                                                                return (
                                                                    <BoxDoc id={x.idFile} style={{ border: fileIndex === i ? '2px solid #026735' : 'none', borderRadius: '10px' }} icon={<icons.box5 />} title={x?.fileName} onClick={() => { setFileIndex(i) }} dropDown checkbox />
                                                                )
                                                            })}
                                                            <Grid item lg={2} sx={{ cursor: 'pointer', position: 'relative', }}>
                                                                <Box sx={{ padding: '10px' }} {...getRootProps({ className: 'dropzone' })}>
                                                                    <input {...getInputProps()} />
                                                                    <Box onClick={open} sx={{
                                                                        position: 'relative',
                                                                        display: 'flex',
                                                                        width: '140px',
                                                                        height: '140px',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        borderRadius: 'var(--main-system-4-px, 4px)',
                                                                        border: '1px dashed #C1C3C7',
                                                                    }}><UploadIcon sx={{ fontSize: '32px', color: "#C1C3C7" }} /></Box>
                                                                </Box>
                                                            </Grid>
                                                        </Grid> :
                                                        <PDFViewer file={file} style={{ width: '100%', height: '75vh' }} />}

                                                </AccordionDetails>
                                            </Accordion>

                                            <Accordion defaultExpanded sx={{
                                                boxShadow: 'none', ':before': {
                                                    content: '""',
                                                    height: "0px"
                                                }
                                            }}>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                    style={{ padding: '0px' }}

                                                >
                                                    <Typography sx={{ fontWeight: '500' }}>ดัชนีข้อมูลเอกสาร</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails sx={{ display: 'flex', flexDirection: 'column', gap: '20px', padding: '0px' }}>
                                                    {file[fileIndex]?.formDocument_0_Name && <InputTextField required={file[fileIndex].formDocument_0_Status || null} heading={file[fileIndex].formDocument_0_Name} value={file[fileIndex].formDocument_0_Value || ''} onchange={(e) => {
                                                        setFile(file.map((x: any) => {
                                                            return {
                                                                ...x,
                                                                formDocument_0_Value: e.target.value
                                                            }
                                                        }))
                                                        clearErrorMessage()
                                                    }} helperText={
                                                        errorMessage.formDocument_0_Name || ''
                                                    } />}
                                                    {file[fileIndex]?.formDocument_1_Name && <InputTextField required={file[fileIndex].formDocument_1_Status || null} heading={file[fileIndex].formDocument_1_Name} value={file[fileIndex].formDocument_1_Value || ''} onchange={(e) => {
                                                        // setFile((prevData: any) => {
                                                        //     const newData = [...prevData];
                                                        //     newData[fileIndex] = { ...newData[fileIndex], ['formDocument_1_Value']: e.target.value };
                                                        //     return newData;
                                                        // });
                                                        setFile(file.map((x: any) => {
                                                            return {
                                                                ...x,
                                                                formDocument_1_Value: e.target.value
                                                            }
                                                        }))
                                                        clearErrorMessage()
                                                    }} helperText={
                                                        errorMessage.formDocument_1_Name || ''
                                                    } />}
                                                    {file[fileIndex]?.formDocument_2_Name && <InputTextField required={file[fileIndex].formDocument_2_Status || null} heading={file[fileIndex].formDocument_2_Name} value={file[fileIndex].formDocument_2_Value || ''} onchange={(e) => {
                                                        setFile(file.map((x: any) => {
                                                            return {
                                                                ...x,
                                                                formDocument_2_Value: e.target.value
                                                            }
                                                        }))
                                                        clearErrorMessage()
                                                    }} helperText={
                                                        errorMessage.formDocument_2_Name || ''
                                                    } />}
                                                    {file[fileIndex]?.formDocument_3_Name && <InputTextField required={file[fileIndex].formDocument_3_Status || null} heading={file[fileIndex].formDocument_3_Name} value={file[fileIndex].formDocument_3_Value || ''} onchange={(e) => {
                                                        setFile(file.map((x: any) => {
                                                            return {
                                                                ...x,
                                                                formDocument_3_Value: e.target.value
                                                            }
                                                        }))
                                                        clearErrorMessage()
                                                    }} helperText={
                                                        errorMessage.formDocument_3_Name || ''
                                                    } />}
                                                    {file[fileIndex]?.formDocument_4_Name && <InputTextField required={file[fileIndex].formDocument_4_Status || null} heading={file[fileIndex].formDocument_4_Name} value={file[fileIndex].formDocument_4_Value || ''} onchange={(e) => {
                                                        setFile(file.map((x: any) => {
                                                            return {
                                                                ...x,
                                                                formDocument_4_Value: e.target.value
                                                            }
                                                        }))
                                                        clearErrorMessage()
                                                    }} helperText={
                                                        errorMessage.formDocument_4_Name || ''
                                                    } />}
                                                    {file[fileIndex]?.formDocument_5_Name && <InputTextField required={file[fileIndex].formDocument_5_Status || null} heading={file[fileIndex].formDocument_5_Name} value={file[fileIndex].formDocument_5_Value || ''} onchange={(e) => {
                                                        setFile(file.map((x: any) => {
                                                            return {
                                                                ...x,
                                                                formDocument_5_Value: e.target.value
                                                            }
                                                        }))
                                                        clearErrorMessage()
                                                    }} helperText={
                                                        errorMessage.formDocument_5_Name || ''
                                                    } />}
                                                    {file[fileIndex]?.formDocument_6_Name && <InputTextField required={file[fileIndex].formDocument_6_Status || null} heading={file[fileIndex].formDocument_6_Name} value={file[fileIndex].formDocument_6_Value || ''} onchange={(e) => {
                                                        setFile(file.map((x: any) => {
                                                            return {
                                                                ...x,
                                                                formDocument_6_Value: e.target.value
                                                            }
                                                        }))
                                                        clearErrorMessage()
                                                    }} helperText={
                                                        errorMessage.formDocument_6_Name || ''
                                                    } />}
                                                    {file[fileIndex]?.formDocument_7_Name && <InputTextField required={file[fileIndex].formDocument_7_Status || null} heading={file[fileIndex].formDocument_7_Name} value={file[fileIndex].formDocument_7_Value || ''} onchange={(e) => {
                                                        setFile(file.map((x: any) => {
                                                            return {
                                                                ...x,
                                                                formDocument_7_Value: e.target.value
                                                            }
                                                        }))
                                                        clearErrorMessage()
                                                    }} helperText={
                                                        errorMessage.formDocument_7_Name || ''
                                                    } />}
                                                    {file[fileIndex]?.formDocument_8_Name && <InputTextField required={file[fileIndex].formDocument_8_Status || null} heading={file[fileIndex].formDocument_8_Name} value={file[fileIndex].formDocument_8_Value || ''} onchange={(e) => {
                                                        setFile(file.map((x: any) => {
                                                            return {
                                                                ...x,
                                                                formDocument_8_Value: e.target.value
                                                            }
                                                        }))
                                                        clearErrorMessage()
                                                    }} helperText={
                                                        errorMessage.formDocument_8_Name || ''
                                                    } />}
                                                    {file[fileIndex]?.formDocument_9_Name && <InputTextField required={file[fileIndex].formDocument_9_Status || null} heading={file[fileIndex].formDocument_9_Name} value={file[fileIndex].formDocument_9_Value || ''} onchange={(e) => {
                                                        setFile(file.map((x: any) => {
                                                            return {
                                                                ...x,
                                                                formDocument_9_Value: e.target.value
                                                            }
                                                        }))
                                                        clearErrorMessage()
                                                    }} helperText={
                                                        errorMessage.formDocument_9_Name || ''
                                                    } />}

                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion defaultExpanded sx={{
                                                padding: '0px',
                                                boxShadow: 'none', ':before': {
                                                    content: '""',
                                                    height: "0px"
                                                }
                                            }}>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                    style={{ padding: '0px' }}
                                                >
                                                    <Typography sx={{ fontWeight: '500' }}>ข้อมูลเอกสาร</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails sx={{ display: 'flex', flexDirection: 'column', gap: '20px', padding: '0px' }}>
                                                    <InputTextField heading='ชื่อเอกสาร' value={file[fileIndex]?.fileName || ''} onchange={(e) => {
                                                        setFile((prevData: any) => {
                                                            const newData = [...prevData];
                                                            newData[fileIndex] = { ...newData[fileIndex], ['fileName']: e.target.value };
                                                            return newData;
                                                        });
                                                    }} />
                                                    {/* <div>
                                                    <FilterSelect heading='ประเภทไฟล์' labelId='' selectId='' options={[{ value: 'pdf', name: 'pdf' },].map((x, i) => {
                                                        return (
                                                            <MenuItem key={i}
                                                                value={x.value}
                                                            >
                                                                {x.name}
                                                            </MenuItem>
                                                        )
                                                    })} value={'pdf'} style={{ width: '140px' }} onchange={(e: any) => { }} />
                                                </div> */}
                                                    {/* <div>
                                                    <FilterSelect heading='ตำแหน่งเอกสารจริง' labelId='' selectId='' options={[{ value: 'เวลาที่สร้างก่อน', name: 'เวลาที่สร้างก่อน' },].map((x, i) => {
                                                        return (
                                                            <MenuItem key={i}
                                                                value={x.value}
                                                            >
                                                                {x.name}
                                                            </MenuItem>
                                                        )
                                                    })} value={''} onchange={(e: any) => { }} />
                                                </div> */}
                                                    <InputTextField heading='ตำแหน่งเอกสารจริง' value={file[fileIndex]?.fileLocation} onchange={(e) => {
                                                        setFile((prevData: any) => {
                                                            const newData = [...prevData];
                                                            newData[fileIndex] = { ...newData[fileIndex], ['fileLocation']: e.target.value };
                                                            return newData;
                                                        });
                                                    }} />

                                                </AccordionDetails>
                                            </Accordion>
                                        </div>
                                        <div style={{ display: "flex", justifyContent: 'flex-end' }}>

                                            <ButtonCustom variant={'outlined'}
                                                // startIcon={<icons.iconUpload />}
                                                textButton={'คัดลอกดัชนี'}
                                                onClick={() => { setCopyIndex(true) }}
                                                style={{ marginRight: '4px' }}
                                                btnStyle={{
                                                    '&.MuiButton-outlined': {
                                                        color: `#EEA23E !important`,
                                                        border: `2px solid #EEA23E !important`,
                                                        borderRadius: "10px !important",
                                                        '&:hover': {
                                                            color: `#EEA23E  !important`,
                                                            border: `2px solid #EEA23E !important`,
                                                            backgroundColor: '#FFFAF2 !important'
                                                        },
                                                    },
                                                }} />
                                            <ButtonCustom variant={'outlined'}
                                                textButton={'คืนค่า'}
                                                style={{ marginRight: '4px' }}
                                                onClick={() => {
                                                    if (type === 'My') {
                                                        const loadDataLevel = async () => {
                                                            const res = await FolderApi.getMyFolder(idFolder)
                                                            const data = await res.data;
                                                            if (data?.success) {
                                                                setFile(acceptedFiles.map((x) => {
                                                                    return {
                                                                        ...data.result.formDocument,
                                                                        fileName: x.name,
                                                                        fileLocation: "",
                                                                        formDocument_0_Name: data.result.formDocument?.formDocument_0,
                                                                        formDocument_0_Value: null,
                                                                        formDocument_1_Name: data.result.formDocument?.formDocument_1,
                                                                        formDocument_1_Value: null,
                                                                        formDocument_2_Name: data.result.formDocument?.formDocument_2,
                                                                        formDocument_2_Value: null,
                                                                        formDocument_3_Name: data.result.formDocument?.formDocument_3,
                                                                        formDocument_3_Value: null,
                                                                        formDocument_4_Name: data.result.formDocument?.formDocument_4,
                                                                        formDocument_4_Value: null,
                                                                        formDocument_5_Name: data.result.formDocument?.formDocument_5,
                                                                        formDocument_5_Value: null,
                                                                        formDocument_6_Name: data.result.formDocument?.formDocument_6,
                                                                        formDocument_6_Value: null,
                                                                        formDocument_7_Name: data.result.formDocument?.formDocument_7,
                                                                        formDocument_7_Value: null,
                                                                        formDocument_8_Name: data.result.formDocument?.formDocument_8,
                                                                        formDocument_8_Value: null,
                                                                        formDocument_9_Name: data.result.formDocument?.formDocument_9,
                                                                        formDocument_9_Value: null,
                                                                        file: x
                                                                    }
                                                                }));
                                                            }
                                                        }
                                                        loadDataLevel()
                                                    } else {
                                                        const loadDataLevel = async () => {
                                                            const res = await FolderApi.getSharedFolder(idFolder)
                                                            const data = await res.data;
                                                            if (data?.success) {
                                                                setFile(acceptedFiles.map((x) => {
                                                                    return {
                                                                        ...data.result.formDocument,
                                                                        fileName: x.name,
                                                                        fileLocation: "",
                                                                        formDocument_0_Name: data.result.formDocument?.formDocument_0,
                                                                        formDocument_0_Value: null,
                                                                        formDocument_1_Name: data.result.formDocument?.formDocument_1,
                                                                        formDocument_1_Value: null,
                                                                        formDocument_2_Name: data.result.formDocument?.formDocument_2,
                                                                        formDocument_2_Value: null,
                                                                        formDocument_3_Name: data.result.formDocument?.formDocument_3,
                                                                        formDocument_3_Value: null,
                                                                        formDocument_4_Name: data.result.formDocument?.formDocument_4,
                                                                        formDocument_4_Value: null,
                                                                        formDocument_5_Name: data.result.formDocument?.formDocument_5,
                                                                        formDocument_5_Value: null,
                                                                        formDocument_6_Name: data.result.formDocument?.formDocument_6,
                                                                        formDocument_6_Value: null,
                                                                        formDocument_7_Name: data.result.formDocument?.formDocument_7,
                                                                        formDocument_7_Value: null,
                                                                        formDocument_8_Name: data.result.formDocument?.formDocument_8,
                                                                        formDocument_8_Value: null,
                                                                        formDocument_9_Name: data.result.formDocument?.formDocument_9,
                                                                        formDocument_9_Value: null,
                                                                        file: x
                                                                    }
                                                                }));
                                                            }
                                                        }
                                                        loadDataLevel()
                                                    }
                                                }} />
                                            <ButtonCustom variant={'outlined'}
                                                // endIcon={<icons.downloadButton />}
                                                disabled={loading}
                                                textButton={'บันทึก'}
                                                onClick={() => {
                                                    handleSubmit()
                                                }}
                                                btnStyle={{
                                                    '&.MuiButton-outlined': {
                                                        color: `#fff !important`,
                                                        border: `2px solid #026735 !important`,
                                                        backgroundColor: '#026735 !important',
                                                        borderRadius: "10px !important",
                                                        '&:hover': {
                                                            color: `#fff  !important`,
                                                            border: `2px solid #026735 !important`,
                                                            backgroundColor: '#026735 !important'
                                                        },
                                                    },
                                                }} />

                                        </div>
                                    </>
                                </Box>
                            </Box>
                        </Box> :
                            <Box sx={{ padding: '40px' }}>
                                <div style={{
                                    borderRadius: '10px',
                                    border: '1px dashed #C1C3C7',
                                    padding: '56px',
                                    marginBottom: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '629px'
                                }} {...getRootProps({ className: 'dropzone' })}>
                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }}>
                                        <icons.uploadCloud />
                                        <Typography sx={{ fontSize: '14px', fontWeight: '500', marginTop: '24px' }}>ลากหรือเลือกไฟล์เพื่ออัปโหลด</Typography>
                                        <Typography sx={{ fontSize: '14px', fontWeight: '300', color: 'rgba(0, 0, 0, 0.40)', marginBottom: '24px' }}>ขนาดไม่เกิน {index?.size?.documentSizeName || '10MB'}</Typography>
                                        <ButtonCustom variant={'outlined'}
                                            // endIcon={<icons.downloadButton />}
                                            textButton={'เลือกไฟล์'}
                                            onClick={open}
                                            btnStyle={{
                                                '&.MuiButton-outlined': {
                                                    color: `#0A77FF !important`,
                                                    border: `1px dashed #0A77FF !important`,
                                                    backgroundColor: '#fff !important',
                                                    borderRadius: "10px !important",
                                                    '&:hover': {
                                                        color: `#0A77FF  !important`,
                                                        border: `1px dashed #0A77FF !important`,
                                                        backgroundColor: '#fff !important'
                                                    },
                                                },
                                            }} />
                                    </div>
                                    <input {...getInputProps()} />

                                </div>
                                <div style={{ display: "flex", justifyContent: 'flex-end' }}>

                                    <ButtonCustom variant={'outlined'}
                                        startIcon={<icons.iconUpload />}
                                        textButton={'ตั้งค่าอัปโหลดเอกสาร'}
                                        onClick={() => { setSettingUpload(true) }}
                                        style={{ marginRight: '4px' }}
                                        btnStyle={{
                                            '&.MuiButton-outlined': {
                                                color: `#EEA23E !important`,
                                                border: `2px solid #EEA23E !important`,
                                                borderRadius: "10px !important",
                                                '&:hover': {
                                                    color: `#EEA23E  !important`,
                                                    border: `2px solid #EEA23E !important`,
                                                    backgroundColor: '#FFFAF2 !important'
                                                },
                                            },
                                        }} />
                                </div>
                            </Box>}
                        <ClearIcon sx={{ cursor: 'pointer', fontSize: "20px", position: 'absolute', top: '20px', right: '16px' }} onClick={() => {
                            handleClose()
                            clearErrorMessage()
                        }} />

                    </DialogContent>}
        </Dialog >
    )
}
